import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const apiClient = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle response errors
apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authApi = {
    register: (data) => apiClient.post('/auth/register', data),
    login: (data) => apiClient.post('/auth/login', data),
    getMe: () => apiClient.get('/auth/me')
};

// Projects API
export const projectsApi = {
    getAll: (params) => apiClient.get('/projects', { params }),
    getOne: (id) => apiClient.get(`/projects/${id}`),
    create: (data) => apiClient.post('/projects', data),
    update: (id, data) => apiClient.put(`/projects/${id}`, data),
    delete: (id) => apiClient.delete(`/projects/${id}`),
    exportExcel: async (params) => {
        const response = await apiClient.get('/projects/export/excel', {
            params,
            responseType: 'blob'
        });
        return response;
    }
};

// Statistics API
export const statisticsApi = {
    get: () => apiClient.get('/statistics')
};

// Gmail API
export const gmailApi = {
    getAuthUrl: () => apiClient.get('/gmail/auth-url'),
    callback: (code, state) => apiClient.post('/gmail/callback', null, { params: { code, state } }),
    getEmails: () => apiClient.get('/gmail/emails'),
    approveEmail: (emailId, data) => apiClient.post(`/gmail/emails/${emailId}/approve`, data),
    disconnect: () => apiClient.delete('/gmail/disconnect')
};

export default apiClient;
